var languagesForm = {
    bindings : {
        addMsg: '&'
    },
    /**
     * @ngInject
     */
    controller : function LanguagesFormCtrl ($sce, $timeout, flux, actions) {
        
        var ctrl = this;
        var formData = {};
        var selectedLanguages = [];
        ctrl.languages = [
            {
                id: 'Arabisk',
                selected: false
            },
            {
                id: 'Dansk',
                selected: false
            },
            {
                id: 'Engelsk',
                selected: false
            },
            {
                id: 'Fransk',
                selected: false
            },
            {
                id: 'Italiensk',
                selected: false
            },
            {
                id: 'Japansk',
                selected: false
            },
            {
                id: 'Kinesisk',
                selected: false
            },
            {
                id: 'Norsk',
                selected: false
            },
            {
                id: 'Persisk',
                selected: false
            },
            {
                id: 'Polsk',
                selected: false
            },
            {
                id: 'Portugisisk',
                selected: false
            },
            {
                id: 'Russisk',
                selected: false
            },
            {
                id: 'Spansk',
                selected: false
            },
            {
                id: 'Somali',
                selected: false
            },
            {
                id: 'Svensk',
                selected: false
            },
            {
                id: 'Tyrkisk',
                selected: false
            },
            {
                id: 'Tysk',
                selected: false
            },
            {
                id: 'Ukrainsk',
                selected: false
            },
            {
                id: 'Urdu',
                selected: false
            }
        ];
       

        function init () {
        }

        function link () {
        }

        function onChanges (changes) {
        }

        ctrl.submitForm = function submitForm() {
            
            if(selectedLanguages.length >= 1) {
                formData.languages = selectedLanguages;
                var messages = _.map(selectedLanguages, function(value, key){
                    return '<span class="text-answer">'+value+'</span>';
                });
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml(messages.join('')),
                        type: 'send'
                    }
                });
                flux.dispatch(actions.UPDATE_USER, formData);
                $timeout(function() {
                    ctrl.addMsg({
                        $event: {
                            content: $sce.trustAsHtml('Du har virkelig sprogøre! Det skal du nok få brug for <a href="/din-ansoegning">Godkend dit valg ved at trykke her.</a> '),
                            type: 'receive'
                        }
                    });
                }, 1000);
            } else {
                ctrl.addMsg({
                    $event: {
                        content: $sce.trustAsHtml('Ups, du skal vælge minimum 1 sprog.'),
                        type: 'receive'
                    }
                });
            }
        };

        ctrl.onLanguageChange = function onLanguageChange(target){
            if(selectedLanguages.length == 5) {
                target.selected = false;
            }
            selectedLanguages = _.chain(ctrl.languages).filter({'selected':true}).map('id').value();
        };

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl: './angular/components/languages-form.component.html',
};